import React, { useEffect, useState } from "react";
import { DashboardLayout } from "@/components/Layout/DashboardLayout";
import { LayoutDashboard, Package, DollarSign } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";
import { useCurrency } from "@/contexts/CurrencyContext";

const items = (t) => [
  { to: "/rider", icon: LayoutDashboard, label: t("dashboard"), end: true, tid: "rider-nav-dashboard" },
  { to: "/rider/jobs", icon: Package, label: t("availableJobs"), tid: "rider-nav-jobs" },
  { to: "/rider/earnings", icon: DollarSign, label: t("earnings"), tid: "rider-nav-earnings" },
];

export default function RiderJobs() {
  const { t } = useLang();
  const { formatPrice } = useCurrency();
  const [jobs, setJobs] = useState([]);
  const load = () => api.get("/orders/available-for-riders").then(r => setJobs(r.data));
  useEffect(() => { load(); const i = setInterval(load, 4000); return () => clearInterval(i); }, []);

  const accept = async (id) => { await api.post(`/orders/${id}/accept`); load(); };

  return (
    <DashboardLayout items={items(t)} title={t("availableJobs")}>
      {jobs.length === 0 ? (
        <div className="text-center py-20 text-[var(--so-text-soft)]" data-testid="no-jobs">No available jobs right now. Stay online!</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-3">
          {jobs.map(j => (
            <div key={j.id} className="so-card p-4" data-testid={`job-${j.id}`}>
              <div className="flex items-center justify-between">
                <div className="font-bold">{j.restaurant_name}</div>
                <div className="text-[var(--so-orange)] font-bold">{formatPrice(j.delivery_fee)}</div>
              </div>
              <div className="text-sm text-[var(--so-text-soft)]">→ {j.customer_name}</div>
              <div className="text-xs mt-1 text-[var(--so-text-soft)]">{j.address}</div>
              <div className="text-xs mt-1">{j.items.length} items · Total {formatPrice(j.total)}</div>
              <button onClick={() => accept(j.id)} className="so-btn-primary text-sm w-full justify-center mt-3" data-testid={`accept-${j.id}`}>
                {t("accept")}
              </button>
            </div>
          ))}
        </div>
      )}
    </DashboardLayout>
  );
}
